import { createAction } from 'redux-actions';
import { TOGGLE_USER_SETTING_POPUP, SET_USER_SETTING_ACTIVE_TAB } from '../constants/actionTypes';


const toggleUserSettingPopUpAction = createAction(TOGGLE_USER_SETTING_POPUP);
const UserSettingActiveTabAction = createAction(SET_USER_SETTING_ACTIVE_TAB);

// eslint-disable-next-line import/prefer-default-export
export function toggleUserSettingPopUp() {
  return dispatch => dispatch(toggleUserSettingPopUpAction())
}

export function UserSettingActiveTab(data) {
  return dispatch => dispatch(UserSettingActiveTabAction(data))
}